import { LogInsightsView } from "./LogInsightsView";

/**
 * Log Reviewer Insights — the Team Lead review queue. Acknowledges or rejects
 * justifications raised on the Overview dashboard.
 *
 * Body only: the page title, strapline and tab strip belong to the Change
 * Assurance Governance shell, which renders this through an <Outlet />.
 *
 * TODO(rbac): gate on the `log_review_insights` permission once the Log
 * Review modules are added to RBAC_MATRIX.
 */
export const LogReviewerInsightsPage = () => <LogInsightsView role="reviewer" />;
